function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingingOutbound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.42,6.88c-1.57.91-2.34,2.78-2.26,5.35a15.64,15.64,0,0,0,2.19,6.9,15.48,15.48,0,0,0,4.8,5.31c2.07,1.4,4.15,1.64,5.76.75h0L21,24.51a1.05,1.05,0,0,0,.38-1.38l-2.09-3.62a1.05,1.05,0,0,0-1.38-.38l-1.13.59c-.5.28-2.46.22-4-2.59s-.77-4.48-.19-4.79l1.14-.58a1.06,1.06,0,0,0,.38-1.39l-2-3.58a1.06,1.06,0,0,0-1.39-.38C10.59,6.24,9.42,6.88,9.42,6.88Z",
    style: {
      fill: "#7e7e7e"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "24.84 9.67 18.61 9.01 19.96 10.94 17.28 12.82 19.31 15.72 22 13.83 23.35 15.76 24.84 9.67",
    style: {
      fill: "#e44918"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingingOutbound);
export default __webpack_public_path__ + "static/media/ringing-outbound.6eaa516a.svg";
export { ForwardRef as ReactComponent };